import { useEffect, useState } from "react";

/**
 * Returns true once window.scrollY exceeds `threshold` px. Idempotent —
 * re-renders only when the boolean flips, not on every scroll event.
 */
export function useScrolledPast(threshold = 24) {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > threshold);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [threshold]);
    return scrolled;
}
